import React, { useEffect } from 'react';
import { IPayerAddressItem } from '../Infrastructure/Interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../Store/StoreInit';
import PayerAddressPg from './PayerAddressPg';
import { fetchPayerAddressList } from '../Store/GetDropDownsValuesReducer';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';

interface RootState {  
  payerAddressList: {  
    payerAddressList: IPayerAddressItem[];  
    loading: boolean;  
  };  
}

const PayerAddress: React.FC = () => {
  const { payerAddressList, loading } = useSelector((state: RootState) => state.payerAddressList);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchPayerMasterList());
    dispatch(fetchPayerAddressList());
  }, []);

  if (loading) {
    return (
      <div className="contentDiv">
        <h3>Loading...</h3>
      </div>
    );
  }

  if (!payerAddressList) {
    return <h3>Data not found...</h3>;
  }
  return (
      <PayerAddressPg PayerAddressList={payerAddressList} />
  );
}

export default PayerAddress;
